<!-- main-content + container-fluid son los que dan el ancho y el padding
     dentro del layout de admin. Sin ellos el contenido se desborda a la
     derecha y aparece scroll horizontal. -->
<div class="main-content table-page table-page--compact table-page--dense vac">
  <div class="container-fluid">

  <!-- ===== 1. Encabezado: qué pantalla es, qué hace esta sección y la
       acción principal ===== -->
  <section class="table-page__hero vac-hero">
    <div class="table-page__copy">
      <h1>Vacaciones</h1>
      <p>{{ subPestana }}</p>
    </div>
    <div class="table-page__toolbar-actions">
      <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
              (click)="abrirAlta()">
        <span class="material-icons">add</span>
        Agregar vacaciones
      </button>
    </div>
  </section>

  <!-- Lo que espera respuesta ya no va aquí, en una banda encima de las
       pestañas (13/10/2026, Norman: «mejor otra pestaña que se llame
       Autorizaciones … mejor controlado y bien visible»): vive en su
       pestaña, que lleva la cuenta en rojo. -->

  <!-- ===== 2. Navegar: SOLO las secciones =====
       Subrayadas, como pestañas: se ven distintas de Mes | Año, que no
       lleva a otra sección sino que cambia cómo se ve el calendario.
       En celular son una barra de seis con el icono arriba (CSS): por
       eso «Autorizaciones», «Periodos vigentes» y «Configuración» traen
       su versión corta. -->
  <nav class="vac-secciones" aria-label="Secciones de Vacaciones">
    <button type="button" class="vac-seccion"
            [class.is-activa]="pestana === 'calendario'"
            [attr.aria-current]="pestana === 'calendario' ? 'page' : null"
            (click)="verPestana('calendario')">
      <span class="material-icons" aria-hidden="true">calendar_month</span>
      <span class="vac-seccion__txt">Calendario</span>
    </button>

    <!-- Lo que espera respuesta, vacaciones y permisos juntos. Su número
         no es un conteo: es un aviso, y va en rojo lleno esté o no
         abierta la pestaña. -->
    <button type="button" class="vac-seccion"
            [class.is-activa]="pestana === 'autorizaciones'"
            [attr.aria-current]="pestana === 'autorizaciones' ? 'page' : null"
            (click)="verPestana('autorizaciones')">
      <span class="material-icons" aria-hidden="true">how_to_reg</span>
      <span class="vac-seccion__txt"><span class="vac-seccion__largo">Autorizaciones</span><span class="vac-seccion__corto">Autorizar</span></span>
      <span class="vac-seccion__n vac-seccion__n--aviso" *ngIf="totalPorAutorizar"
            [matTooltip]="tipPorAutorizar" matTooltipClass="vac-tip">
        {{ totalPorAutorizar }}
      </span>
    </button>

    <button type="button" class="vac-seccion"
            [class.is-activa]="pestana === 'periodos'"
            [attr.aria-current]="pestana === 'periodos' ? 'page' : null"
            (click)="verPestana('periodos')">
      <span class="material-icons" aria-hidden="true">event_note</span>
      <span class="vac-seccion__txt">Periodos<span class="vac-seccion__largo"> vigentes</span></span>
      <span class="vac-seccion__n" *ngIf="periodosVigentes.length">{{ periodosVigentes.length }}</span>
    </button>

    <button type="button" class="vac-seccion"
            [class.is-activa]="pestana === 'seguimiento'"
            [attr.aria-current]="pestana === 'seguimiento' ? 'page' : null"
            (click)="verPestana('seguimiento')">
      <span class="material-icons" aria-hidden="true">fact_check</span>
      <span class="vac-seccion__txt">Seguimiento</span>
      <span class="vac-seccion__n" *ngIf="delAnio.length">{{ delAnio.length }}</span>
    </button>

    <!-- Los permisos tienen su propio calendario: una vacación es una
         franja de días y un permiso es un punto en uno solo. Los que
         esperan respuesta se cuentan en «Autorizaciones». -->
    <button type="button" class="vac-seccion"
            [class.is-activa]="pestana === 'permisos'"
            [attr.aria-current]="pestana === 'permisos' ? 'page' : null"
            (click)="verPestana('permisos')">
      <span class="material-icons" aria-hidden="true">assignment_turned_in</span>
      <span class="vac-seccion__txt">Permisos</span>
    </button>

    <button type="button" class="vac-seccion"
            [class.is-activa]="pestana === 'config'"
            [attr.aria-current]="pestana === 'config' ? 'page' : null"
            (click)="verPestana('config')">
      <span class="material-icons" aria-hidden="true">tune</span>
      <span class="vac-seccion__txt"><span class="vac-seccion__largo">Configuración</span><span class="vac-seccion__corto">Ajustes</span></span>
    </button>
  </nav>

  <!-- ===== 3. Trabajar: la barra de Calendario y Periodos =====
       Izquierda: Hoy ‹ › y el mes (que además abre el salto). Van en ese
       orden para que las flechas no se muevan bajo el ratón: «Mayo» es
       más corto que «Septiembre». En la vista de Año, el año.
       Derecha: Mes | Año. Ya no se esconde mientras carga: la barra no
       brinca. -->
  <div class="vac-barra vac-barra--mes" *ngIf="pestana === 'calendario' || pestana === 'periodos'">
    <div class="vac-barra__izq">
      <ng-container *ngIf="mostrarBarraMes; else anioFijo">
        <div class="vac-ir" role="group" aria-label="Cambiar de mes">
          <button type="button" class="vac-ir__hoy" (click)="irAHoy()"
                  matTooltip="Volver al mes de hoy" matTooltipClass="vac-tip">
            <!-- El icono sólo sale en los teléfonos más angostos (CSS). -->
            <span class="material-icons" aria-hidden="true">today</span>
            <span class="vac-ir__hoy-txt">Hoy</span>
          </button>
          <div class="vac-ir__flechas">
            <button type="button" class="vac-ir__flecha" (click)="mesAnterior()"
                    aria-label="Mes anterior" matTooltip="Mes anterior" matTooltipClass="vac-tip">
              <span class="material-icons" aria-hidden="true">chevron_left</span>
            </button>
            <button type="button" class="vac-ir__flecha" (click)="mesSiguiente()"
                    aria-label="Mes siguiente" matTooltip="Mes siguiente" matTooltipClass="vac-tip">
              <span class="material-icons" aria-hidden="true">chevron_right</span>
            </button>
          </div>
        </div>

        <div class="vac-barra__mes">
          <!-- Abre y cierra un grupo de controles (no un menú): por eso
               aria-expanded + aria-controls y no aria-haspopup. -->
          <button type="button" class="vac-barra__titulo" #botonMes (click)="abrirSalto()"
                  [attr.aria-expanded]="saltoAbierto"
                  [attr.aria-controls]="saltoAbierto ? 'vac-salto' : null"
                  matTooltip="Ir a otro mes" matTooltipClass="vac-tip">
            {{ tituloMes }}
            <span class="material-icons" aria-hidden="true">
              {{ saltoAbierto ? 'expand_less' : 'expand_more' }}
            </span>
          </button>

          <!-- Salto directo a otro mes: en escritorio se abre en la misma
               barra, junto al mes; si no cabe, flota debajo. Escape lo
               cierra y el foco regresa al mes. -->
          <div class="vac-salto" id="vac-salto" *ngIf="saltoAbierto"
               role="group" aria-label="Ir a otro mes"
               (keydown.escape)="cerrarSalto()">
            <select class="vac-salto__ctrl" [(ngModel)]="mesElegido" name="saltoMes" aria-label="Mes">
              <option *ngFor="let m of nombresMes; let i = index" [ngValue]="i">{{ m }}</option>
            </select>
            <select class="vac-salto__ctrl" [(ngModel)]="anioElegido" name="saltoAnio" aria-label="Año">
              <option *ngFor="let a of aniosDisponibles" [ngValue]="a">{{ a }}</option>
            </select>
            <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                    (click)="aplicarSalto()">Ir</button>
          </div>
        </div>
      </ng-container>

      <ng-template #anioFijo>
        <span class="vac-barra__titulo vac-barra__titulo--fijo">
          <span class="material-icons" aria-hidden="true">date_range</span>
          Año calendario {{ anioSeguimiento }}
        </span>
      </ng-template>
    </div>

    <div class="vac-barra__der" *ngIf="mostrarVistas">
      <div class="vac-vistas" role="group" aria-label="Vista del calendario">
        <button type="button" class="vac-vista"
                [class.is-on]="vistaCalendario === 'mes'"
                [attr.aria-pressed]="vistaCalendario === 'mes'"
                (click)="verVista('mes')">
          <span class="material-icons" aria-hidden="true">calendar_view_month</span>
          Mes
        </button>
        <button type="button" class="vac-vista"
                [class.is-on]="vistaCalendario === 'anio'"
                [attr.aria-pressed]="vistaCalendario === 'anio'"
                (click)="verVista('anio')">
          <span class="material-icons" aria-hidden="true">calendar_view_week</span>
          Año
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== CALENDARIO · AÑO ====================
       Personas por meses. Contesta de un vistazo lo que la vista de mes
       obliga a averiguar navegando: quién sale en diciembre. -->
  <ng-container *ngIf="pestana === 'calendario' && vistaCalendario === 'anio'">

    <!-- Se dice que es el año CALENDARIO: los días de goce van por periodo
         de aniversario (Configuración), y el Total de aquí no tiene por qué
         cuadrar con los gozados de allá. «Año calendario 2026» ya lo dice
         la barra de arriba: la nota no lo repite. -->
    <div class="vac-seg__cuenta" *ngIf="!cargandoBitacora">
      <span>
        Días hábiles de enero a diciembre. Los días de goce van por
        periodo de aniversario, en Configuración.
      </span>
    </div>

    <div class="vac-card" *ngIf="!cargandoBitacora">
      <div class="vac-tabla-caja" *ngIf="filasAnio.length">
        <table class="vac-anio__tabla">
          <thead>
            <tr>
              <th class="vac-anio__quien">Colaborador</th>
              <th class="c" *ngFor="let m of MESES_CORTOS; index as i"
                  [class.es-mes-hoy]="esMesActual(i)">
                <button type="button" class="vac-anio__mes" (click)="vaAlMes(i)"
                        matTooltip="Ver ese mes" matTooltipClass="vac-tip">
                  {{ m }}
                </button>
              </th>
              <th class="c vac-anio__total">Total</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let f of filasAnio">
              <td class="vac-anio__quien">
                <span class="vac-config__persona">
                  <span class="vac-config__punto" [style.background]="f.color"></span>
                  <span class="vac-config__nombre"
                        [matTooltip]="f.nombre" matTooltipClass="vac-tip">
                    {{ f.nombre }}
                  </span>
                </span>
              </td>

              <td class="c" *ngFor="let d of f.meses; index as i"
                  [class.es-mes-hoy]="esMesActual(i)">
                <!-- El cero no se pinta: una rejilla llena de ceros se
                     lee como ruido y esconde los meses que sí importan. -->
                <span class="vac-anio__dias" *ngIf="d > 0"
                      [style.background]="tinte(f.color, 0.16)"
                      [style.borderColor]="tinte(f.color, 0.38)"
                      [style.color]="f.color">
                  {{ d }}
                </span>
                <span class="vac-anio__nada" *ngIf="!d">·</span>
              </td>

              <td class="c vac-anio__total">{{ f.total }}</td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <td class="vac-anio__quien">Personas fuera</td>
              <td class="c" *ngFor="let n of personasPorMes; index as i"
                  [class.es-mes-hoy]="esMesActual(i)">
                <span [class.vac-anio__nada]="!n">{{ n || '·' }}</span>
              </td>
              <td class="c vac-anio__total">{{ filasAnio.length }}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="vac-vacio" *ngIf="!filasAnio.length">
        <span class="material-icons vac-vacio__icono">event_available</span>
        <p>Nadie tiene vacaciones en el año calendario {{ anioSeguimiento }}.</p>
      </div>
    </div>

    <div class="vac-cargando" *ngIf="cargandoBitacora">
      <span class="material-icons vac-cargando__icono">hourglass_top</span>
      Consultando el año…
    </div>
  </ng-container>

  <!-- ==================== CALENDARIO · MES ==================== -->
  <ng-container *ngIf="pestana === 'calendario' && vistaCalendario === 'mes'">

    <!-- Quién descansa se ve en la rejilla misma. El resumen de arriba
         («4 días», «1 persona» y una ficha por persona) se quitó el
         24/09/2026 a pedido de Norman: con mucha gente se amontonaba. -->
    <div class="vac-card">
      <div class="vac-cargando" *ngIf="cargando">
        <span class="material-icons vac-cargando__icono">hourglass_top</span>
        Cargando el mes…
      </div>

      <table class="vac-tabla" *ngIf="!cargando"
             [class.es-vacio]="!enDescanso.length">
        <thead>
          <tr>
            <th *ngFor="let d of diasSemana">{{ d }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let semana of semanas">
            <td *ngFor="let dia of semana; trackBy: trackDia"
                class="vac-dia"
                [class.vac-dia--vacio]="dia.numero === null"
                [class.vac-dia--hoy]="dia.esHoy"
                [class.vac-dia--ocupado]="dia.periodos.length">

              <ng-container *ngIf="dia.numero !== null">
                <div class="vac-dia__cab">
                  <span class="vac-dia__num">{{ dia.numero }}</span>
                  <button type="button" class="vac-dia__mas"
                          (click)="abrirAlta(dia.iso)"
                          [attr.aria-label]="'Agregar vacaciones el ' + dia.numero"
                          matTooltip="Agregar vacaciones este día"
                          matTooltipClass="vac-tip">
                    <span class="material-icons">add</span>
                  </button>
                </div>

                <div class="vac-dia__lista">
                  <!-- tabindex y (click): la informacion no puede vivir solo
                       en el hover. Con raton se sigue viendo al pasar por
                       encima; ademas ahora se abre al tocar (celular, y
                       trackpad de Mac, donde el hover se pierde con nada) y
                       al llegar con el tabulador, que Material ya atiende
                       solo cuando el foco viene del teclado. -->
                  <div class="vac-tag" *ngFor="let v of dia.periodos; trackBy: trackVacacion"
                       #tipVac="matTooltip"
                       tabindex="0"
                       role="button"
                       [attr.aria-label]="tipVacacion(v)"
                       (click)="tipVac.toggle()"
                       (keydown.escape)="tipVac.hide(0)"
                       [style.background]="tinte(v.color, 0.14)"
                       [style.borderColor]="tinte(v.color, 0.32)"
                       [style.color]="v.color"
                       [matTooltip]="tipVacacion(v)"
                       matTooltipClass="vac-tip"
                       matTooltipPosition="above"
                       [matTooltipShowDelay]="120">
                    <span class="material-icons vac-tag__icono">beach_access</span>
                    <span class="vac-tag__nombre">{{ v.colaborador }}</span>
                    <!-- Sólo en celular (CSS): el nombre completo no
                         cabe en una columna de 46 px. -->
                    <span class="vac-tag__ini">{{ iniciales(v.colaborador) }}</span>
                  </div>

                  <!-- Quien regresa: se marca distinto, no es vacación -->
                  <div class="vac-tag vac-tag--regreso"
                       *ngFor="let v of dia.regresan; trackBy: trackVacacion"
                       #tipReg="matTooltip"
                       tabindex="0"
                       role="button"
                       [attr.aria-label]="tipRegreso(v)"
                       (click)="tipReg.toggle()"
                       (keydown.escape)="tipReg.hide(0)"
                       [style.borderColor]="v.color"
                       [style.color]="v.color"
                       [matTooltip]="tipRegreso(v)"
                       matTooltipClass="vac-tip"
                       matTooltipPosition="above"
                       [matTooltipShowDelay]="120">
                    <span class="material-icons vac-tag__icono">flight_land</span>
                    <span class="vac-tag__nombre">{{ v.colaborador }}</span>
                  </div>
                </div>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- ==================== PERIODOS VIGENTES ==================== -->
  <ng-container *ngIf="pestana === 'periodos'">
    <div class="vac-lista" *ngIf="periodosVigentes.length && !cargando">
      <div class="vac-periodo" *ngFor="let v of periodosPagina; trackBy: trackVacacion">
        <span class="vac-periodo__color" [style.background]="v.color"></span>
        <div class="vac-periodo__texto">
          <span class="vac-periodo__nombre">{{ v.colaborador }}</span>
          <span class="vac-periodo__rango">{{ textoRango(v) }}</span>
          <span class="vac-periodo__nota" *ngIf="nota(v)">{{ nota(v) }}</span>
        </div>
        <span class="vac-periodo__dias"
              [style.background]="tinte(v.color, 0.12)"
              [style.color]="v.color">
          {{ diasHabiles(v) }} {{ diasHabiles(v) === 1 ? 'día' : 'días' }}
        </span>
        <div class="vac-periodo__acciones">
          <!-- El documento (15/10/2026): ver #docVacacion, abajo. -->
          <span class="vac-doc">
            <ng-container *ngTemplateOutlet="docVacacion; context: { $implicit: v }"></ng-container>
          </span>
          <button type="button" class="vac-ico" (click)="editar(v)"
                  matTooltip="Editar periodo" matTooltipClass="vac-tip">
            <span class="material-icons">edit</span>
          </button>
          <button type="button" class="vac-ico vac-ico--peligro" (click)="quitar(v)"
                  matTooltip="Quitar del calendario" matTooltipClass="vac-tip">
            <span class="material-icons">delete_outline</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Paginación: la lista no crece hacia abajo -->
    <div class="vac-pager" *ngIf="totalPaginas > 1 && !cargando">
      <button type="button" class="vac-pager__btn" (click)="irPagina(pagina - 1)"
              [disabled]="pagina === 1" aria-label="Anterior">
        <span class="material-icons">chevron_left</span>
      </button>
      <button type="button" class="vac-pager__n" *ngFor="let n of paginas"
              [class.is-activa]="n === pagina" (click)="irPagina(n)">{{ n }}</button>
      <button type="button" class="vac-pager__btn" (click)="irPagina(pagina + 1)"
              [disabled]="pagina === totalPaginas" aria-label="Siguiente">
        <span class="material-icons">chevron_right</span>
      </button>
    </div>

    <div class="vac-vacio" *ngIf="!periodosVigentes.length && !cargando">
      <span class="material-icons vac-vacio__icono">event_available</span>
      <p *ngIf="periodosConcluidos.length">
        Nadie está de vacaciones ahora. Hay
        {{ periodosConcluidos.length }}
        {{ periodosConcluidos.length === 1 ? 'periodo ya concluido' : 'periodos ya concluidos' }}
        en la bitácora.
      </p>
      <p *ngIf="!periodosConcluidos.length">
        Nadie tiene vacaciones registradas en {{ tituloMes }}.
      </p>
    </div>
  </ng-container>

  <!-- ==================== BITÁCORA ==================== -->
  <!-- ==================== SEGUIMIENTO ====================
       Qué pasó con cada petición del año: quién la pidió, cuándo, quién
       la resolvió y por qué. Salen TODAS, incluidas las rechazadas y las
       retiradas — una que se negó es justo lo que hay que poder revisar
       después, y hasta ahora ese dato se guardaba sin que nadie pudiera
       verlo. -->
  <ng-container *ngIf="pestana === 'seguimiento'">

    <div class="vac-seg__barra vac-barra">
      <!-- Los estatus como pastillas: además de filtrar, dicen de un
           vistazo cómo va el año. -->
      <div class="vac-seg__estados" role="group" aria-label="Filtrar por estatus">
        <button type="button" class="vac-seg__pill"
                [class.is-activa]="!segEstatus"
                [attr.aria-pressed]="!segEstatus"
                (click)="segEstatus = ''">
          Todas <span class="vac-seg__n">{{ delAnio.length }}</span>
        </button>
        <button type="button" class="vac-seg__pill" *ngFor="let e of ESTATUS_SEG"
                [class.is-activa]="segEstatus === e.valor"
                [attr.aria-pressed]="segEstatus === e.valor"
                [style.borderColor]="segEstatus === e.valor ? e.color : null"
                [style.color]="segEstatus === e.valor ? e.color : null"
                [style.background]="segEstatus === e.valor ? tinte(e.color, 0.1) : null"
                (click)="segEstatus = segEstatus === e.valor ? '' : e.valor">
          <span class="vac-seg__punto" [style.background]="e.color"></span>
          {{ e.texto }}
          <span class="vac-seg__n">{{ cuantasCon(e.valor) }}</span>
        </button>
      </div>

      <div class="vac-seg__herr">
        <label class="vac-selarea">
          <select [(ngModel)]="segArea" name="segArea" aria-label="Área">
            <option value="">Todas las áreas</option>
            <option *ngFor="let a of areasSeguimiento" [value]="a">{{ a }}</option>
          </select>
          <span class="material-icons vac-selarea__flecha" aria-hidden="true">expand_more</span>
        </label>

        <label class="vac-buscar">
          <span class="material-icons" aria-hidden="true">search</span>
          <input type="text" [(ngModel)]="segTexto" name="segTexto"
                 placeholder="Nombre o motivo…" aria-label="Buscar por nombre o motivo" />
          <button type="button" class="vac-buscar__x" *ngIf="segTexto"
                  (click)="segTexto = ''" aria-label="Limpiar">
            <span class="material-icons">close</span>
          </button>
        </label>

        <button type="button" class="vac-seg__btn"
                [disabled]="!seguimiento.length"
                (click)="exportaSeguimiento()"
                matTooltip="Bajar lo que estás viendo del año calendario, en Excel"
                matTooltipClass="vac-tip">
          <span class="material-icons">download</span>
          Exportar
        </button>
      </div>
    </div>

    <div class="vac-seg__cuenta" *ngIf="!cargandoBitacora">
      <b>{{ seguimiento.length }}</b>
      {{ seguimiento.length === 1 ? 'solicitud' : 'solicitudes' }}
      <ng-container *ngIf="hayFiltrosSeg"> de {{ delAnio.length }}</ng-container>
      · <b>{{ totalDiasAnio }}</b>
      {{ totalDiasAnio === 1 ? 'día hábil' : 'días hábiles' }}
      en el año calendario {{ anioSeguimiento }}
      <button type="button" class="vac-seg__limpiar" *ngIf="hayFiltrosSeg"
              (click)="limpiaFiltrosSeg()">
        Quitar filtros
      </button>
    </div>

    <div class="vac-tabla-caja" *ngIf="!cargandoBitacora && seguimiento.length">
      <table class="vac-seg__tabla">
        <thead>
          <tr>
            <th>Colaborador</th>
            <th class="c">Área</th>
            <th>Periodo</th>
            <th class="c">Días</th>
            <th class="c">Estatus</th>
            <th>Resolvió</th>
            <th class="c">Documento</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let v of seguimientoPagina; trackBy: trackVacacion">
            <td>
              <span class="vac-config__persona">
                <span class="vac-config__punto" [style.background]="v.color"></span>
                <!-- Con tooltip: la columna es angosta y un nombre
                     largo se recorta sin dejar forma de leerlo. -->
                <span class="vac-config__nombre"
                      [matTooltip]="v.colaborador || ''"
                      matTooltipClass="vac-tip">{{ v.colaborador }}</span>
              </span>
            </td>

            <td class="c">
              <!-- El tooltip no es adorno: la columna es angosta y el
                   nombre largo se recorta. Sin él, "Dirección
                   Administración/Finanzas" queda ilegible y sin forma
                   de averiguarlo. -->
              <span class="vac-area"
                    [style.background]="tinte(colorArea(areaDe(v.idUsuario)), 0.13)"
                    [style.borderColor]="tinte(colorArea(areaDe(v.idUsuario)), 0.34)"
                    [style.color]="colorArea(areaDe(v.idUsuario))"
                    [matTooltip]="areaDe(v.idUsuario)" matTooltipClass="vac-tip">
                {{ areaDe(v.idUsuario) }}
              </span>
            </td>

            <td>
              <span class="vac-seg__rango">{{ textoRango(v) }}</span>
              <!-- De dónde salió: capturada a mano o pedida por él. Es
                   lo que explica que algunas no tengan quién resuelva. -->
              <span class="vac-seg__origen">
                {{ v.origen === 'SOLICITUD' ? 'la pidió' : 'capturada' }}
              </span>
            </td>

            <td class="c">{{ diasHabiles(v) }}</td>

            <td class="c">
              <span class="vac-seg__estado"
                    [style.background]="tinte(colorEstatus(v.estatus), 0.12)"
                    [style.borderColor]="tinte(colorEstatus(v.estatus), 0.35)"
                    [style.color]="colorEstatus(v.estatus)">
                {{ etiquetaEstatus(v.estatus) }}
              </span>
            </td>

            <td>
              <span class="vac-seg__quien" *ngIf="resolucion(v); else sinResolver">
                {{ resolucion(v) }}
              </span>
              <ng-template #sinResolver>
                <span class="vac-config__falta">
                  {{ v.estatus === 'PENDIENTE' ? 'esperando' : '—' }}
                </span>
              </ng-template>

              <!-- El motivo del rechazo: hasta ahora solo lo veía el
                   colaborador en su tarjeta. -->
              <span class="vac-seg__motivo" *ngIf="v.motivo">
                <span class="material-icons">chat_bubble_outline</span>
                {{ v.motivo }}
              </span>
            </td>

            <!-- El documento (15/10/2026), como en Periodos vigentes (ver
                 #docVacacion). De lo no autorizado o retirado sólo se
                 consulta lo que ya se hubiera subido: ahí no se ofrece
                 cargar. -->
            <td class="c">
              <span class="vac-doc">
                <ng-container *ngTemplateOutlet="docVacacion; context: { $implicit: v }"></ng-container>
                <span class="vac-config__falta" *ngIf="sinDocumento(v)">—</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- De diez en diez: una tabla que crece hacia abajo sin tope
         obliga a hacer scroll para llegar al pie. -->
    <div class="vac-pager vac-pager--seg" *ngIf="!cargandoBitacora && totalPaginasSeg > 1">
      <span class="vac-pager__rango">
        {{ desdeSeg }}–{{ hastaSeg }} de {{ seguimiento.length }}
      </span>
      <button type="button" class="vac-pager__btn" (click)="irPaginaSeg(paginaSeg - 1)"
              [disabled]="paginaSeg <= 1" aria-label="Página anterior">
        <span class="material-icons">chevron_left</span>
      </button>
      <ng-container *ngFor="let n of paginasSeg">
        <span class="vac-pager__hueco" *ngIf="n === 0">…</span>
        <button type="button" class="vac-pager__n" *ngIf="n !== 0"
                [class.is-activa]="n === paginaSeg" (click)="irPaginaSeg(n)">
          {{ n }}
        </button>
      </ng-container>
      <button type="button" class="vac-pager__btn" (click)="irPaginaSeg(paginaSeg + 1)"
              [disabled]="paginaSeg >= totalPaginasSeg" aria-label="Página siguiente">
        <span class="material-icons">chevron_right</span>
      </button>
    </div>

    <div class="vac-vacio" *ngIf="!cargandoBitacora && !seguimiento.length">
      <span class="material-icons vac-vacio__icono">
        {{ hayFiltrosSeg ? 'search_off' : 'fact_check' }}
      </span>
      <p *ngIf="hayFiltrosSeg">Nada coincide con esos filtros.</p>
      <p *ngIf="!hayFiltrosSeg">No hay solicitudes en el año calendario {{ anioSeguimiento }}.</p>
    </div>

    <div class="vac-cargando" *ngIf="cargandoBitacora">
      <span class="material-icons vac-cargando__icono">hourglass_top</span>
      Consultando…
    </div>
  </ng-container>

  <!-- ==================== CONFIGURACION ==================== -->
  <ng-container *ngIf="pestana === 'config'">
    <div class="vac-config">
      <!-- Sin título ni subtítulo: la pestaña ya dice qué es esto. La
           barra es el renglón 3 de la pantalla: a la izquierda de qué día
           son los números y los filtros; a la derecha, subir el Excel. -->
      <div class="vac-barra vac-barra--config">
        <div class="vac-barra__izq">
          <!-- De qué día son los números: los vigentes a hoy si en el
               calendario se veía el mes actual, o a la mitad del mes que se
               veía (la regla del servidor). Si no es hoy, en ámbar, con el
               porqué en el tooltip y el enlace para volver a hoy. -->
          <span class="vac-barra__fecha" *ngIf="fechaSaldos"
                [class.es-otro]="fechaSaldos !== hoyIso"
                [matTooltip]="fechaSaldos !== hoyIso
                  ? 'Según el mes que se veía en el calendario'
                  : 'Los periodos que corren hoy'"
                matTooltipClass="vac-tip">
            <span class="material-icons" aria-hidden="true">
              {{ fechaSaldos !== hoyIso ? 'history' : 'event' }}
            </span>
            Periodos vigentes al
            <b>{{ fechaCompleta(fechaSaldos) }}</b>
            <!-- El porqué, también para el lector de pantalla y el
                 teclado: el tooltip de un span no se alcanza con Tab. -->
            <span class="cdk-visually-hidden" *ngIf="fechaSaldos !== hoyIso">
              (según el mes que se veía en el calendario)
            </span>
          </span>
          <button type="button" class="vac-barra__link"
                  *ngIf="fechaSaldos && fechaSaldos !== hoyIso"
                  (click)="irAHoy()">
            Ver los de hoy
          </button>

          <span class="vac-barra__sep" *ngIf="fechaSaldos" aria-hidden="true"></span>

          <!-- Filtro por área. Un select y no fichas: con diez áreas las
               fichas ocupaban dos renglones y empujaban la tabla fuera
               de la pantalla. El punto de la izquierda lleva el color
               del área elegida, que es lo único que el select nativo no
               puede pintar por sí solo. -->
          <label class="vac-selarea">
            <span class="vac-selarea__punto"
                  [style.background]="areaFiltro ? colorArea(areaFiltro) : '#cbd5e1'"></span>
            <select [ngModel]="areaFiltro" name="areaFiltro" aria-label="Área"
                    [style.color]="areaFiltro ? colorArea(areaFiltro) : null"
                    (ngModelChange)="filtraPorArea($event)">
              <option value="">Todas las áreas ({{ totalOrganigrama }})</option>
              <!-- Cada opción con el color de su área. Chrome y Edge en
                   Windows sí pintan el texto de un <option>; si algún
                   navegador lo ignora, la lista se ve como antes y no se
                   pierde nada. -->
              <option *ngFor="let f of fichasArea" [value]="f.area"
                      [style.color]="colorArea(f.area)">
                {{ f.area }} ({{ f.cuantos }})
              </option>
              <!-- Quien la carga del Excel dio de alta sin estar en el
                   organigrama: va al final, para ponerlo ahí. -->
              <option *ngIf="sinArea" [value]="SIN_AREA">Sin área ({{ sinArea }})</option>
            </select>
            <span class="material-icons vac-selarea__flecha" aria-hidden="true">expand_more</span>
          </label>

          <!-- Capturar 44 personas de una en una es media hora; por área
               son ocho movimientos. -->
          <label class="vac-buscar">
            <span class="material-icons" aria-hidden="true">search</span>
            <input type="text" name="filtroConfig"
                   [ngModel]="filtroConfig" (ngModelChange)="cambiaFiltro($event)"
                   placeholder="Buscar colaborador…" aria-label="Buscar colaborador" />
            <!-- Solo cuando hay algo escrito: un aspa permanente invita a
                 pulsarla sin que haya nada que borrar. -->
            <button type="button" class="vac-buscar__x" *ngIf="filtroConfig"
                    (click)="cambiaFiltro('')" aria-label="Limpiar búsqueda">
              <span class="material-icons">close</span>
            </button>
          </label>
        </div>

        <div class="vac-barra__der">
          <!-- Subir el Excel de RH: el botón, la vista previa fila por
               fila y la carga viven en su propio componente, el mismo de
               Seguimiento RH. Al cargar, se vuelve a pedir el mes para
               que la tabla enseñe lo recién guardado. -->
          <app-carga-excel-vacaciones (cargado)="cargar()"></app-carga-excel-vacaciones>
        </div>
      </div>

      <div class="vac-tabla-caja">
        <!-- Las columnas de la hoja de RH, en su orden: así se coteja
             renglón por renglón contra el Excel sin traducir nada. -->
        <table class="vac-config__tabla">
          <thead>
            <tr>
              <th>Colaborador</th>
              <th class="c">Área</th>
              <th class="c">Autoriza</th>
              <th class="c">Alta IMSS</th>
              <!-- Desde el 24/09/2026 el periodo ES el saldo: del
                   aniversario de su Alta IMSS al siguiente, como la hoja. -->
              <th class="c">Periodo<small>de aniversario</small></th>
              <th class="c vac-config__th-num">Años<small>de antigüedad</small></th>
              <th class="c vac-config__th-num">Días de goce<small>clic para editar</small></th>
              <th class="c vac-config__th-num">Gozados<small>los que tomó</small></th>
              <th class="c vac-config__th-num">Restantes<small>del periodo</small></th>
              <th class="c vac-config__th-num">Acumulado<small>de periodos anteriores</small></th>
              <th class="c vac-config__th-num">Le quedan<small>puede pedir</small></th>
              <th class="c vac-config__th-num">Prima<small>25% en días de salario</small></th>
              <th class="c vac-config__th-acciones">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of colaboradoresPagina; trackBy: trackColaborador">
              <!-- El periodo de la fila se busca una vez y lo usan todas
                   las celdas. Va envuelto en un objeto para que el *ngIf
                   sea siempre verdadero, traiga periodo o no. `bloqueo` es
                   por qué no se puede corregir desde aquí (periodo cerrado
                   o uno mismo), o "" si sí se puede. -->
              <ng-container *ngIf="{ s: saldoDe(c.idUsuario), bloqueo: bloqueoSaldo(c.idUsuario), lapiz: bloqueoPropio(c.idUsuario) } as r">
              <td>
                <span class="vac-config__persona">
                  <span class="vac-config__punto" [style.background]="c.color"></span>
                  <!-- El nombre en su propio span: como nodo de texto suelto
                       no se le puede aplicar el recorte con puntos. -->
                  <span class="vac-config__nombre"
                        [matTooltip]="c.nombre || ''"
                        matTooltipClass="vac-tip">{{ c.nombre }}</span>
                </span>
              </td>

              <td class="c">
                <span class="vac-area" *ngIf="areaDe(c.idUsuario); else sinAreaCelda"
                      [style.background]="tinte(colorArea(areaDe(c.idUsuario)), 0.13)"
                      [style.borderColor]="tinte(colorArea(areaDe(c.idUsuario)), 0.34)"
                      [style.color]="colorArea(areaDe(c.idUsuario))"
                      [matTooltip]="areaDe(c.idUsuario)" matTooltipClass="vac-tip">
                  {{ areaDe(c.idUsuario) }}
                </span>
                <!-- Tiene periodo pero no está en el organigrama (lo dio de
                     alta la carga del Excel de RH): de ahí salen su área y
                     quién le autoriza. -->
                <ng-template #sinAreaCelda>
                  <span class="vac-config__falta"
                        matTooltip="No está en el organigrama: no tiene área ni quién le autorice. Ponlo en el organigrama y se le asignan."
                        matTooltipClass="vac-tip">Sin área</span>
                </ng-template>
              </td>

              <td class="c">
                <ng-container *ngIf="autorizaDe(c.idUsuario); else sinAutoriza">
                  {{ autorizaDe(c.idUsuario) }}
                </ng-container>
                <ng-template #sinAutoriza>
                  <span class="vac-config__falta">Sin asignar</span>
                </ng-template>
              </td>

              <!-- Sin Alta IMSS no hay aniversario: sus días van por año
                   calendario hasta que se capture (con el lápiz). -->
              <td class="c">
                <span class="vac-config__fecha"
                      *ngIf="altaDe(c.idUsuario); else faltaAlta">
                  {{ fechaCompleta(altaDe(c.idUsuario)) }}
                </span>
                <ng-template #faltaAlta>
                  <span class="vac-config__falta"
                        matTooltip="Sin Alta IMSS sus días van por año calendario. Captúrala con el lápiz para que vayan de aniversario a aniversario."
                        matTooltipClass="vac-tip">Falta</span>
                </ng-template>
              </td>

              <!-- "20/09/2026 al 20/09/2027", como la columna «Fin del
                   periodo» de la hoja: el fin es el aniversario siguiente.
                   En dos renglones para que quepa sin ensanchar la tabla. -->
              <td class="c">
                <span class="vac-config__periodo"
                      *ngIf="r.s?.periodoInicio && r.s?.periodoFin; else guion"
                      [matTooltip]="tipPeriodo(c.idUsuario)" matTooltipClass="vac-tip">
                  <span class="vac-config__periodo-fechas">{{ fechaCompleta(r.s.periodoInicio) }}</span>
                  <span class="vac-config__periodo-fechas">al {{ fechaCompleta(r.s.periodoFin) }}</span>
                  <span class="vac-config__calendario"
                        *ngIf="r.s.porAniversario === false">año calendario</span>
                  <span class="vac-config__vence es-vencido"
                        *ngIf="estadoPeriodo(c.idUsuario) === 'CERRADO'">Cerrado</span>
                  <span class="vac-config__vence es-porvencer"
                        *ngIf="estadoPeriodo(c.idUsuario) === 'PORCERRAR'">Por cerrar</span>
                </span>
              </td>

              <!-- Años cumplidos al EMPEZAR el periodo: con ellos salen los
                   días de ley. Los calcula el servidor. -->
              <td class="c">
                <span *ngIf="r.s?.antiguedad != null; else guion"
                      [matTooltip]="tipAntiguedad(r.s)" matTooltipClass="vac-tip">
                  {{ r.s.antiguedad }}
                </span>
              </td>

              <td class="c">
                <!-- En edición: el campo. Enter guarda, Escape cancela,
                     y salir del campo también guarda, que es lo que hace
                     todo el mundo sin pensarlo. -->
                <input *ngIf="editandoDias === c.idUsuario; else verDias"
                       type="number" class="vac-dias__campo" aria-label="Días de goce"
                       min="0" max="60" #campoDias
                       [(ngModel)]="borradorDias"
                       [name]="'dias' + c.idUsuario"
                       (blur)="guardaDias(c)"
                       (keydown.enter)="guardaDias(c)"
                       (keydown.escape)="cancelaDias()" />

                <!-- Un periodo cerrado o los días propios el servidor los
                     rechaza siempre: la celda se apaga y dice por qué. Va
                     con aria-disabled y no con [disabled] para que el
                     tooltip salga (un botón deshabilitado no recibe el
                     cursor); el clic lo detiene editaDias. -->
                <ng-template #verDias>
                  <button type="button" class="vac-dias"
                          [class.es-vacio]="totalesDe(c.idUsuario) === null"
                          [class.is-bloqueado]="!!r.bloqueo"
                          [attr.aria-disabled]="r.bloqueo ? 'true' : null"
                          [disabled]="guardandoDias === c.idUsuario"
                          (click)="editaDias(c)"
                          [matTooltip]="r.bloqueo || ('Clic para capturar los días de goce' +
                            (r.s?.diasPorLey != null ? ' · por ley le tocan ' + r.s.diasPorLey : ''))"
                          matTooltipClass="vac-tip">
                    <span *ngIf="guardandoDias === c.idUsuario"
                          class="material-icons vac-dias__espera">hourglass_top</span>
                    <ng-container *ngIf="guardandoDias !== c.idUsuario">
                      {{ totalesDe(c.idUsuario) === null ? '—' : totalesDe(c.idUsuario) }}
                    </ng-container>
                  </button>
                </ng-template>
              </td>

              <!-- Gozados = tomados en COS + gozados antes de COS (la hoja
                   de RH). El tooltip desglosa la suma: sin él, un número
                   mayor al de la bitácora parecería un error. Desde el
                   20/10/2026 con «lo que le sobra primero» (../saldo-vista):
                   lo que pidió para su siguiente periodo cuenta aquí. -->
              <td class="c">
                <span [matTooltip]="desgloseGozadosVista(r.s)" matTooltipClass="vac-tip">
                  {{ gozadosVistaDe(r.s) }}
                </span>
              </td>

              <!-- «Días restantes» de la hoja: goce − gozados, sin lo
                   acumulado. Negativo = tomó más de lo que le tocaba. -->
              <td class="c">
                <span *ngIf="restantesVistaDe(r.s) !== null; else guion"
                      [class.vac-num--negativo]="restantesVistaDe(r.s) < 0">
                  {{ restantesVistaDe(r.s) }}
                </span>
              </td>

              <!-- Lo que le sobró de periodos anteriores. Si salió solo de
                   su periodo anterior (no lo fijó RH) se dice debajo. -->
              <td class="c">
                <span class="vac-config__acum"
                      *ngIf="acumuladoVistaDe(r.s) !== null; else guion"
                      [class.vac-num--negativo]="acumuladoVistaDe(r.s) < 0"
                      [matTooltip]="tipAcumulado(r.s)" matTooltipClass="vac-tip">
                  {{ acumuladoVistaDe(r.s) }}
                  <small class="vac-config__acum-de"
                         *ngIf="r.s?.arrastreCalculado && acumuladoVistaDe(r.s) !== 0">del anterior</small>
                </span>
              </td>

              <!-- Lo que de verdad puede pedir: restantes + acumulado. -->
              <td class="c">
                <span class="vac-config__quedan"
                      *ngIf="quedanVistaDe(r.s) !== null; else guion"
                      [class.es-poco]="quedanVistaDe(r.s) <= 2"
                      [matTooltip]="desgloseQuedanVista(r.s)" matTooltipClass="vac-tip">
                  {{ quedanVistaDe(r.s) }}
                </span>
              </td>

              <!-- El 25% de la LFT, en días de salario, sobre los días de
                   goce (lo acumulado no la sube). En pesos no se puede: COS
                   no guarda sueldos. Nómina lo multiplica. -->
              <td class="c">
                <span class="vac-config__prima"
                      *ngIf="primaDe(c.idUsuario) !== null; else guion"
                      matTooltip="25% de los días de goce de su periodo, en días de salario (LFT art. 80). Lo acumulado no la sube. El monto lo calcula nómina."
                      matTooltipClass="vac-tip">
                  {{ primaDe(c.idUsuario) }}
                </span>
              </td>

              <td class="c">
                <button type="button" class="vac-ico" (click)="abrirSaldo(c.idUsuario)"
                        [class.is-bloqueado]="!!r.lapiz"
                        [attr.aria-disabled]="r.lapiz ? 'true' : null"
                        [matTooltip]="r.lapiz || 'Días de goce, periodo, fecha de ingreso y quién autoriza'"
                        matTooltipClass="vac-tip">
                  <span class="material-icons">edit</span>
                </button>
              </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginado: cuántos por página, y a cuál ir -->
      <div class="vac-config__pie" *ngIf="colaboradoresFiltrados.length">
        <div class="vac-config__cuantos">
          <span>Ver</span>
          <div class="vac-tams">
            <button type="button" class="vac-tam" *ngFor="let n of TAMANOS"
                    [class.is-activo]="porPaginaConfig === n"
                    (click)="cambiaTamano(n)">{{ n }}</button>
          </div>
          <span class="vac-config__rango">
            <b>{{ desdeConfig }}-{{ hastaConfig }}</b> de
            <b>{{ colaboradoresFiltrados.length }}</b>
            <ng-container *ngIf="areasVisibles"> · {{ areasVisibles }}
              {{ areasVisibles === 1 ? 'área' : 'áreas' }}</ng-container>
          </span>
        </div>

        <div class="vac-pager" *ngIf="totalPaginasConfig > 1">
          <button type="button" class="vac-pager__btn"
                  (click)="irPaginaConfig(paginaConfig - 1)"
                  [disabled]="paginaConfig === 1" aria-label="Anterior">
            <span class="material-icons">chevron_left</span>
          </button>

          <ng-container *ngFor="let n of paginasConfig">
            <span class="vac-pager__hueco" *ngIf="n === 0">…</span>
            <button type="button" class="vac-pager__n" *ngIf="n !== 0"
                    [class.is-activa]="n === paginaConfig"
                    (click)="irPaginaConfig(n)">{{ n }}</button>
          </ng-container>

          <button type="button" class="vac-pager__btn"
                  (click)="irPaginaConfig(paginaConfig + 1)"
                  [disabled]="paginaConfig === totalPaginasConfig" aria-label="Siguiente">
            <span class="material-icons">chevron_right</span>
          </button>
        </div>
      </div>

      <div class="vac-config__vacio" *ngIf="!colaboradoresFiltrados.length">
        <span class="material-icons">search_off</span>
        No hay ningún colaborador con ese nombre.
      </div>
    </div>
  </ng-container>

  <ng-template #guion><span class="vac-config__falta">—</span></ng-template>

  <!-- El documento de una vacación (15/10/2026), para Periodos vigentes y
       Seguimiento. Irving: RH audita, así que ve, baja y carga el documento
       de cada solicitud. El FRC-019 si se pidió y se firmó; lo que se haya
       subido, con su historial (quién y cuándo); y, de lo de otro que siga
       vivo —pedido o capturado aquí—, cargar uno nuevo aunque no se haya
       firmado en papel. Lo propio lo carga otra persona que administre. -->
  <ng-template #docVacacion let-v>
    <button type="button" class="vac-ico" *ngIf="vacacionConFrc(v)"
            [disabled]="generandoFrc === v.idVacacion"
            (click)="frcDe(v)" aria-label="Bajar el FRC-019"
            matTooltip="Bajar el FRC-019" matTooltipClass="vac-tip">
      <span class="material-icons" aria-hidden="true">picture_as_pdf</span>
    </button>
    <app-frc-firmado variante="icono"
                     tipo="VACACION"
                     [id]="v.idVacacion"
                     [enPapel]="!!v.enPapel"
                     [firmado]="v.firmado"
                     [gestiona]="true"
                     [puedeSubir]="rhCargaVacacion(v, miId)"
                     (cambio)="v.firmado = $event"></app-frc-firmado>
  </ng-template>

  <!-- ==================== Autorizaciones ====================
       13/10/2026 (Norman: «mejor otra pestaña que se llame Autorizaciones
       y ahí salgan las de vacaciones y permisos para que se autoricen …
       mejor controlado, bien visible y fácil de usar»). Una sola tabla
       del estándar con lo que espera respuesta, de lo más próximo a lo
       más lejano: quién, qué pide, cuándo, su documento y la respuesta.
       Sustituye a la banda «N solicitudes esperan tu respuesta» que iba
       encima de las pestañas y a la de «N permisos esperan respuesta»
       del calendario de permisos. -->
  <ng-container *ngIf="pestana === 'autorizaciones'">
    <!-- Los permisos se resuelven con las piezas del calendario de
         permisos (escoger el goce, firmar el FRC-017, resolver): aquí va
         sin pintar su mes, sólo para prestarlas. -->
    <app-permisos-calendario #accionesPermiso modo="acciones"
                             (resuelto)="cuentaPermisos()"></app-permisos-calendario>

    <section class="table-page__card vac-aut" aria-label="Solicitudes que esperan tu respuesta">
      <!-- Qué ver: las dos cosas o una sola, cada una con cuántas hay. -->
      <div class="vac-aut__barra" *ngIf="porAutorizar.length">
        <fieldset class="vac-aut__filtros">
          <legend class="cdk-visually-hidden">Qué solicitudes ver</legend>
          <button type="button" class="vac-aut__filtro" *ngFor="let f of FILTROS_AUT"
                  [class.is-activo]="filtroAut === f.id"
                  [attr.aria-pressed]="filtroAut === f.id"
                  [disabled]="!cuantasAut(f.id)"
                  (click)="filtraAut(f.id)">
            <span class="material-icons" aria-hidden="true">{{ f.icono }}</span>
            {{ f.texto }}
            <span class="vac-aut__filtro-n">{{ cuantasAut(f.id) }}</span>
          </button>
        </fieldset>
      </div>

      <!-- Vacío del estándar: nadie espera. -->
      <div class="table-page__empty vac-aut__vacio" *ngIf="!porAutorizar.length">
        <span class="material-icons" aria-hidden="true">task_alt</span>
        <h3>Nada espera tu respuesta.</h3>
        <p>Cuando alguien pida vacaciones o un permiso, aparece aquí para autorizarlo.</p>
      </div>

      <ng-container *ngIf="porAutorizar.length">
        <div class="table-page__table-wrap" #tablaAut>
          <table class="table-page__table vac-aut__tabla">
            <thead>
              <tr>
                <th>Colaborador</th>
                <th>Qué pide</th>
                <th>Cuándo</th>
                <th>Documento</th>
                <th class="vac-aut__resp">Respuesta</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of autPagina; trackBy: trackAut">
                <td>
                  <span class="table-page__name vac-aut__quien">{{ f.colaborador }}</span>
                  <!-- Quien resuelve en lugar de otro ve por qué le llegó. -->
                  <span class="vac-aut__suplencia" *ngIf="f.suplencia">{{ f.suplencia }}</span>
                </td>

                <td>
                  <span class="vac-aut__que" [ngClass]="f.clase">
                    <span class="material-icons" aria-hidden="true">{{ f.icono }}</span>
                    {{ f.que }}
                  </span>
                  <!-- Lo que escribió quien pide, en una línea; entero, al
                       pasar encima. -->
                  <span class="vac-aut__nota" *ngIf="f.nota"
                        [matTooltip]="f.nota" matTooltipClass="vac-tip">{{ f.nota }}</span>
                </td>

                <td>
                  <span class="vac-aut__cuando">
                    {{ f.cuando }}
                    <span class="vac-solicitud__dias" *ngIf="f.dias !== null">
                      {{ f.dias }} {{ f.dias === 1 ? 'día' : 'días' }}
                    </span>
                  </span>
                  <span class="vac-aut__detalle" *ngIf="f.detalle">{{ f.detalle }}</span>
                </td>

                <!-- El documento firmado por quien pide, para verlo antes de
                     resolver; y, si se firmó en papel, el papel: quien
                     administra lo ve y lo sube desde aquí. Desde el
                     15/10/2026 quien administra (RH) también carga el de
                     otro aunque se haya firmado en digital; lo propio, sólo
                     el papel, como antes. -->
                <td>
                  <div class="vac-aut__docs">
                    <ng-container *ngIf="f.vacacion as v">
                      <button type="button" class="vac-btn-mini vac-btn-mini--doc"
                              *ngIf="v.tieneFirma"
                              [disabled]="generandoFrc === v.idVacacion"
                              (click)="frcDe(v)"
                              matTooltip="El FRC-019 firmado por quien pide"
                              matTooltipClass="vac-tip">
                        <span class="material-icons" aria-hidden="true">description</span>
                        FRC-019
                      </button>
                      <app-frc-firmado *ngIf="v.tieneFirma"
                                       variante="mini"
                                       tipo="VACACION"
                                       [id]="v.idVacacion"
                                       [enPapel]="!!v.enPapel"
                                       [firmado]="v.firmado"
                                       [gestiona]="true"
                                       [puedeSubir]="!!v.enPapel || rhCargaVacacion(v, miId)"
                                       (cambio)="v.firmado = $event"></app-frc-firmado>
                      <span class="vac-aut__sin" *ngIf="!v.tieneFirma">Sin documento</span>
                    </ng-container>

                    <ng-container *ngIf="f.permiso as p">
                      <button type="button" class="vac-btn-mini vac-btn-mini--doc"
                              *ngIf="accionesPermiso.tieneFrc(p)"
                              [disabled]="accionesPermiso.generandoFrc === p.idPermiso"
                              (click)="accionesPermiso.frcDe(p)"
                              matTooltip="El FRC-017 firmado por quien pide"
                              matTooltipClass="vac-tip">
                        <span class="material-icons" aria-hidden="true">description</span>
                        FRC-017
                      </button>
                      <!-- Sin papel ya no se esconde (15/10/2026): RH carga el
                           de otro aunque se haya firmado en digital. -->
                      <app-frc-firmado *ngIf="accionesPermiso.tieneFrc(p)"
                                       variante="mini"
                                       tipo="PERMISO"
                                       [id]="p.idPermiso"
                                       [enPapel]="!!p.enPapel"
                                       [firmado]="p.firmado"
                                       [gestiona]="true"
                                       [puedeSubir]="!!p.enPapel || rhCargaPermiso(p, miId)"
                                       (cambio)="p.firmado = $event"></app-frc-firmado>
                      <span class="vac-aut__sin" *ngIf="!accionesPermiso.tieneFrc(p)">Sin documento</span>
                    </ng-container>
                  </div>
                </td>

                <td class="vac-aut__resp">
                  <div class="vac-aut__botones" *ngIf="f.vacacion as v">
                    <button type="button" class="vac-btn-mini vac-btn-mini--si"
                            [disabled]="resolviendo === v.idVacacion"
                            (click)="autorizar(v)"
                            matTooltip="Autorizar y pintar en el calendario"
                            matTooltipClass="vac-tip">
                      <span class="material-icons" aria-hidden="true">check</span>
                      Autorizar
                    </button>
                    <button type="button" class="vac-btn-mini vac-btn-mini--no"
                            [disabled]="resolviendo === v.idVacacion"
                            (click)="rechazar(v)"
                            matTooltip="No autorizar, diciendo por qué"
                            matTooltipClass="vac-tip">
                      <span class="material-icons" aria-hidden="true">close</span>
                      No
                    </button>
                  </div>

                  <ng-container *ngIf="f.permiso as p">
                    <div class="vac-aut__botones" *ngIf="accionesPermiso.puedeResolver(p); else permisoPropio">
                      <button type="button" class="vac-btn-mini vac-btn-mini--si"
                              [disabled]="accionesPermiso.resolviendo === p.idPermiso"
                              (click)="accionesPermiso.autorizar(p)"
                              matTooltip="Autorizar, con goce o sin goce de sueldo"
                              matTooltipClass="vac-tip">
                        <span class="material-icons" aria-hidden="true">check</span>
                        Autorizar
                      </button>
                      <button type="button" class="vac-btn-mini vac-btn-mini--no"
                              [disabled]="accionesPermiso.resolviendo === p.idPermiso"
                              (click)="accionesPermiso.rechazar(p)"
                              matTooltip="No autorizar, diciendo por qué"
                              matTooltipClass="vac-tip">
                        <span class="material-icons" aria-hidden="true">close</span>
                        No
                      </button>
                    </div>
                    <!-- Nadie se autoriza a sí mismo. -->
                    <ng-template #permisoPropio>
                      <span class="vac-aut__propio">Es tu propio permiso: lo resuelve tu líder.</span>
                    </ng-template>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pie del estándar: cuántas son y, sólo con más de una página,
             el paginado. -->
        <div class="table-page__footer">
          <div class="table-page__meta">
            <span>
              <b>{{ autFiltradas }}</b>
              {{ autFiltradas === 1 ? 'espera' : 'esperan' }} tu respuesta<ng-container *ngIf="filtroAut !== 'todas'"> (de {{ porAutorizar.length }})</ng-container>
            </span>
          </div>
          <nav class="table-page__pager" *ngIf="totalPaginasAut > 1" aria-label="Páginas de autorizaciones">
            <button type="button" class="table-page__pager-link" (click)="mueveAut(-1)"
                    [disabled]="paginaAut <= 1" title="Página anterior" aria-label="Página anterior">
              <span class="material-icons" aria-hidden="true">chevron_left</span>
            </button>
            <span class="vac-aut__pagina">{{ paginaAut }} de {{ totalPaginasAut }}</span>
            <button type="button" class="table-page__pager-link" (click)="mueveAut(1)"
                    [disabled]="paginaAut >= totalPaginasAut" title="Página siguiente" aria-label="Página siguiente">
              <span class="material-icons" aria-hidden="true">chevron_right</span>
            </button>
          </nav>
        </div>
      </ng-container>
    </section>
  </ng-container>

  <!-- ==================== Calendario de permisos ====================
       Dentro del contenedor, como los demás bloques de pestaña: fuera
       de él se pintaba al final de la página y obligaba a bajar. -->
  <ng-container *ngIf="pestana === 'permisos'">
    <!-- Al resolver uno desde el mes, el aviso de la pestaña se recuenta. -->
    <app-permisos-calendario
      (resuelto)="cuentaPermisos()"
    ></app-permisos-calendario>
  </ng-container>

  </div>
</div>

<!-- ===== Panel de alta y edición ===== -->
<!-- El fondo NO cierra: un clic de mas borraba todo lo capturado.
     La salida son Cancelar, Guardar o la X de arriba. -->
<div class="vac-overlay" *ngIf="panelAbierto" (click)="insisteEnCerrar()" (keydown.enter)="insisteEnCerrar()"></div>
<aside class="vac-panel" [class.is-tiron]="tiron" *ngIf="panelAbierto">
  <div class="vac-panel__cab">
    <h3>
      <span class="material-icons">{{ editando ? 'edit_calendar' : 'event_note' }}</span>
      {{ editando ? 'Editar vacaciones' : 'Agregar vacaciones' }}
    </h3>
    <button type="button" class="vac-panel__cerrar" (click)="cerrarAlta()"
            aria-label="Cerrar">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="vac-panel__cuerpo">
    <!-- Con buscador (15/10/2026, Irving: el <select> nativo era una lista
         inmensa sin búsqueda). Ver #selectorPersona, al final. -->
    <div class="vac-campo">
      <span class="vac-campo__et" id="vac-et-colaborador">Colaborador</span>
      <ng-container *ngTemplateOutlet="selectorPersona; context: { $implicit: 'colaborador' }"></ng-container>
    </div>

    <!-- Saldo del colaborador elegido, del periodo del que se van a
         descontar los días: el que contiene el PRIMER día. Sólo se tiene
         en pantalla el periodo vigente a la fecha del calendario; si el
         primer día cae en otro, se dice y no se frena (valida el servidor). -->
    <div class="vac-saldo" *ngIf="borrador.idUsuario">
      <ng-container *ngIf="borradorFueraDePeriodo">
        <span class="vac-saldo__sinasignar vac-saldo__fuera">
          <span class="material-icons">info</span>
          {{ textoFueraDePeriodo }}
        </span>
      </ng-container>

      <ng-container *ngIf="!borradorFueraDePeriodo && disponiblesDelBorrador !== null">
        <div class="vac-saldo__cifras">
          <span class="vac-saldo__dato">
            <b>{{ saldoDelBorrador?.diasTotales }}</b>
            <small>días de goce</small>
          </span>
          <span class="vac-saldo__sep">−</span>
          <!-- Los tomados de COS MÁS lo gozado antes de COS (la hoja de
               RH): si aquí saliera solo lo de COS, la resta de al lado no
               cuadraría con el número de la derecha. -->
          <span class="vac-saldo__dato"
                [matTooltip]="desgloseGozados(saldoDelBorrador)" matTooltipClass="vac-tip">
            <b>{{ gozadosDe(saldoDelBorrador) }}</b>
            <small>gozados</small>
          </span>
          <span class="vac-saldo__sep">=</span>
          <span class="vac-saldo__dato vac-saldo__dato--fuerte"
                [class.es-negativo]="disponiblesDelBorrador < 0"
                [matTooltip]="desgloseQuedan(saldoDelBorrador)" matTooltipClass="vac-tip">
            <b>{{ disponiblesDelBorrador }}</b>
            <small>le quedan</small>
          </span>
        </div>

        <!-- De qué periodo son, y lo acumulado: no cabe en la resta de
             tres cifras pero sí está sumado (o restado) en "le quedan".
             Se dice en voz alta para que no parezca un error de cuentas. -->
        <small class="vac-saldo__arrastre">
          En su periodo {{ periodoTexto(saldoDelBorrador) }}<ng-container
            *ngIf="acumuladoDe(saldoDelBorrador) > 0">
            · +{{ acumuladoDe(saldoDelBorrador) }} acumulados de periodos anteriores, ya sumados</ng-container><ng-container
            *ngIf="acumuladoDe(saldoDelBorrador) < 0">
            · −{{ -acumuladoDe(saldoDelBorrador) }} que tomó de más antes, ya descontados</ng-container><ng-container
            *ngIf="(saldoDelBorrador?.prestados || 0) > 0">
            · de esos, {{ saldoDelBorrador?.prestados }} ya los apartan sus vacaciones de su siguiente periodo</ng-container>
        </small>
        <button type="button" class="vac-saldo__editar"
                (click)="abrirSaldo(borrador.idUsuario)"
                matTooltip="Cambiar los días de goce de su periodo"
                matTooltipClass="vac-tip">
          <span class="material-icons">tune</span>
        </button>
      </ng-container>

      <ng-container *ngIf="!borradorFueraDePeriodo && disponiblesDelBorrador === null">
        <span class="vac-saldo__sinasignar">
          <span class="material-icons">info</span>
          Sin días asignados en su periodo{{ saldoDelBorrador ? ' ' + periodoTexto(saldoDelBorrador) : '' }}
        </span>
        <button type="button" class="vac-saldo__asignar"
                (click)="abrirSaldo(borrador.idUsuario)">
          Asignar
        </button>
      </ng-container>
    </div>

    <!-- Fechas: el datepicker no deja elegir sábado ni domingo -->
    <div class="vac-campo-fila">
      <div class="vac-campo">
        <span class="vac-campo__et">Primer día</span>
        <mat-form-field appearance="outline" class="vac-fecha">
          <input matInput aria-label="Primer día" [matDatepicker]="dpIni"
                 [matDatepickerFilter]="soloHabiles"
                 [ngModel]="fIni"
                 (ngModelChange)="fechaDesdePicker($event, 'fechaInicio')"
                 name="inicio" placeholder="Elige un día" />
          <mat-datepicker-toggle matIconSuffix [for]="dpIni"></mat-datepicker-toggle>
          <mat-datepicker #dpIni></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="vac-campo">
        <span class="vac-campo__et">Último día</span>
        <mat-form-field appearance="outline" class="vac-fecha">
          <input matInput aria-label="Último día" [matDatepicker]="dpFin"
                 [matDatepickerFilter]="soloHabiles"
                 [ngModel]="fFin"
                 (ngModelChange)="fechaDesdePicker($event, 'fechaFin')"
                 name="fin" placeholder="Elige un día" />
          <mat-datepicker-toggle matIconSuffix [for]="dpFin"></mat-datepicker-toggle>
          <mat-datepicker #dpFin></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="vac-campo">
      <span class="vac-campo__et">
        Regresa el
        <small>se propone solo, saltando el fin de semana</small>
      </span>
      <mat-form-field appearance="outline" class="vac-fecha">
        <input matInput aria-label="Regresa el" [matDatepicker]="dpReg"
               [matDatepickerFilter]="soloHabiles"
               [ngModel]="fReg"
               (ngModelChange)="fechaDesdePicker($event, 'fechaRegreso')"
               name="regreso" placeholder="Elige un día" />
        <mat-datepicker-toggle matIconSuffix [for]="dpReg"></mat-datepicker-toggle>
        <mat-datepicker #dpReg></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Color del periodo -->
    <div class="vac-campo">
      <span class="vac-campo__et">
        Color
        <small>con el que se pinta en el calendario</small>
      </span>
      <div class="vac-colores">
        <button type="button" class="vac-color" *ngFor="let c of COLORES"
                [class.is-elegido]="borrador.color === c"
                [style.background]="tinte(c, 0.16)"
                [style.borderColor]="borrador.color === c ? c : tinte(c, 0.35)"
                (click)="borrador.color = c"
                [attr.aria-label]="'Color ' + c">
          <span class="vac-color__punto" [style.background]="c"></span>
          <span class="material-icons vac-color__check" *ngIf="borrador.color === c"
                [style.color]="c">check</span>
        </button>

        <!-- El noveno: un color a la medida. El input nativo va encima,
             transparente, para que el clic en cualquier parte de la
             pastilla abra el selector del sistema sin que la pastilla
             pierda el aspecto de las otras ocho. -->
        <label class="vac-color vac-color--libre"
               [class.is-elegido]="colorEsLibre"
               [style.background]="colorEsLibre ? tinte(borrador.color, 0.16) : null"
               [style.borderColor]="colorEsLibre ? borrador.color : null"
               matTooltip="Crear un color" matTooltipClass="vac-tip">
          <span class="vac-color__punto vac-color__punto--arcoiris"></span>
          <span class="material-icons vac-color__check" *ngIf="colorEsLibre"
                [style.color]="borrador.color">check</span>
          <input type="color" class="vac-color__nativo" name="colorLibre"
                 [ngModel]="borrador.color || COLORES[0]"
                 (ngModelChange)="eligeColorLibre($event)"
                 aria-label="Crear un color" />
        </label>

        <!-- El código, para poder copiarlo o dictarlo -->
        <span class="vac-color__hex" *ngIf="borrador.color">{{ borrador.color }}</span>
      </div>
    </div>

    <label class="vac-campo">
      <span class="vac-campo__et">Comentario <small>opcional</small></span>
      <input type="text" class="vac-campo__ctrl" maxlength="300"
             [(ngModel)]="borrador.comentario" name="comentario"
             placeholder="Ej. Vacaciones de verano" />
    </label>

    <!-- Cuenta de días, y el aviso si se pasa -->
    <div class="vac-cuenta" *ngIf="diasDelBorrador > 0 && !seExcede">
      <span class="material-icons">event_available</span>
      <span>
        Son <b>{{ diasDelBorrador }}</b>
        {{ diasDelBorrador === 1 ? 'día hábil' : 'días hábiles' }} de descanso.
        <ng-container *ngIf="quedarianTras !== null">
          Le quedarían <b>{{ quedarianTras }}</b> en su periodo.
        </ng-container>
      </span>
    </div>

    <!-- Sólo cuando el primer día cae en el periodo que está en pantalla:
         si cae en otro, seExcede es falso y valida el servidor. -->
    <div class="vac-cuenta vac-cuenta--alerta" *ngIf="seExcede">
      <span class="material-icons">error_outline</span>
      <span>
        Estas vacaciones son <b>{{ diasDelBorrador }}</b> días hábiles y solo le
        quedan <b>{{ disponiblesDelBorrador }}</b> en su periodo
        {{ periodoTexto(saldoDelBorrador) }}. No se puede guardar así.
      </span>
    </div>
  </div>

  <div class="vac-panel__pie">
    <button type="button" class="vac-btn vac-btn--plano" (click)="cerrarAlta()"
            [disabled]="guardando">
      Cancelar
    </button>
    <button type="button" class="vac-btn vac-btn--primario" (click)="guardar()"
            [disabled]="guardando || seExcede">
      <span class="material-icons">{{ guardando ? 'hourglass_top' : 'check' }}</span>
      {{ guardando ? 'Guardando…' : 'Guardar' }}
    </button>
  </div>
</aside>

<!-- ===== Días que le corresponden ===== -->
<div class="vac-overlay vac-overlay--alto" *ngIf="saldoAbierto" (click)="insisteEnCerrar()" (keydown.enter)="insisteEnCerrar()"></div>
<div class="vac-modal vac-modal--dias" [class.is-tiron]="tiron" *ngIf="saldoAbierto">
  <div class="vac-modal__cab">
    <h3>
      <span class="material-icons">tune</span>
      Días de vacaciones
    </h3>
    <button type="button" class="vac-panel__cerrar" (click)="cerrarSaldo()"
            aria-label="Cerrar">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="vac-modal__cuerpo">
    <!-- Con buscador, como el del panel de alta (15/10/2026). -->
    <div class="vac-campo">
      <span class="vac-campo__et" id="vac-et-saldoQuien">Colaborador</span>
      <ng-container *ngTemplateOutlet="selectorPersona; context: { $implicit: 'saldoQuien' }"></ng-container>
    </div>

    <!-- De la persona, no del periodo: se captura una vez (es la Alta
         IMSS de la hoja de RH) y con ella sus periodos van de aniversario
         a aniversario y los días salen por ley. -->
    <label class="vac-campo">
      <span class="vac-campo__et">
        Fecha de ingreso
        <small>su Alta IMSS · con ella sus periodos van de aniversario a aniversario</small>
      </span>
      <input type="date" class="vac-campo__ctrl" [max]="hoyIso"
             [(ngModel)]="borradorSaldo.fechaIngreso" name="saldoIngreso"
             (ngModelChange)="cambiaIngreso()" />
      <!-- La antigüedad y los días de ley los manda el servidor: son los
           años cumplidos al EMPEZAR el periodo, no la resta de años. -->
      <small class="vac-campo__ayuda"
             *ngIf="!ingresoCambio && saldoModal?.antiguedad != null">
        {{ saldoModal.antiguedad }}
        {{ saldoModal.antiguedad === 1 ? 'año cumplido' : 'años cumplidos' }}
        al inicio de su periodo ({{ fechaCompleta(saldoModal.periodoInicio) }})
        <ng-container *ngIf="saldoModal.diasPorLey != null">
          → <b>{{ saldoModal.diasPorLey }} días</b> por ley (LFT art. 76)
        </ng-container>
      </small>
      <small class="vac-campo__ayuda"
             *ngIf="!ingresoCambio && !borradorSaldo.fechaIngreso">
        Sin fecha de ingreso sus días van por año calendario.
      </small>
      <small class="vac-campo__ayuda vac-campo__ayuda--aviso"
             *ngIf="ingresoCambio && borradorSaldo.fechaIngreso">
        Al guardar, sus periodos pasan a ir de aniversario a aniversario. Los días
        de goce se quedan en blanco para que COS ponga los de ley.
      </small>
      <small class="vac-campo__ayuda vac-campo__ayuda--aviso"
             *ngIf="ingresoCambio && !borradorSaldo.fechaIngreso">
        Al guardar se quita su fecha de ingreso. Los periodos que ya van de
        aniversario a aniversario se quedan así.
      </small>
    </label>

    <div class="vac-campo-fila">
      <!-- Desde el 20/10/2026 el periodo SE ELIGE (Norman: «que se pueda
           editar el periodo para dejarlos bien»): el anterior al vigente, el
           vigente o los que siguen, los que manda el servidor; el año en que
           empieza viaja como llave. Sus fechas siguen saliendo de la Alta
           IMSS. Con una fecha de ingreso nueva, o con uno solo, se queda como
           texto. Sin periodo, el servidor usa su periodo vigente. -->
      <div class="vac-campo vac-campo--periodo">
        <span class="vac-campo__et" id="vac-et-saldoPeriodo">
          Periodo <small *ngIf="resumenPeriodoModal">{{ resumenPeriodoModal }}</small>
        </span>
        <mat-form-field *ngIf="periodosModal.length > 1 && !(ingresoCambio && borradorSaldo.fechaIngreso); else periodoFijo"
                        appearance="outline" class="vac-fecha vac-persona" subscriptSizing="dynamic">
          <mat-select id="vac-saldoPeriodo" aria-labelledby="vac-et-saldoPeriodo" panelClass="vac-persona-panel"
                      panelWidth="" [ngModel]="borradorSaldo.anio" name="saldoPeriodo"
                      (ngModelChange)="eligePeriodoModal($event)">
            <mat-select-trigger>{{ textoFechas(saldoModal) }}</mat-select-trigger>
            <mat-option *ngFor="let p of periodosModal" [value]="p.anio">{{ textoPeriodoModal(p) }}</mat-option>
          </mat-select>
        </mat-form-field>
        <ng-template #periodoFijo>
          <span class="vac-campo__fijo">{{ periodoModalTexto }}</span>
        </ng-template>
      </div>
      <label class="vac-campo">
        <span class="vac-campo__et">Días de goce</span>
        <input type="number" class="vac-campo__ctrl" min="0" max="60"
               [placeholder]="ingresoCambio && borradorSaldo.fechaIngreso ? 'Los de ley' : ''"
               [(ngModel)]="borradorSaldo.diasTotales" name="saldoDias" />
      </label>
    </div>

    <!-- Con buscador (15/10/2026); sin nadie elegido dice «Nadie en
         particular», como antes. -->
    <div class="vac-campo">
      <span class="vac-campo__et" id="vac-et-saldoAutoriza">
        Quién autoriza
        <small>quien resuelve sus solicitudes</small>
      </span>
      <ng-container *ngTemplateOutlet="selectorPersona; context: { $implicit: 'saldoAutoriza' }"></ng-container>
    </div>

    <label class="vac-campo">
      <span class="vac-campo__et">Nota <small>opcional</small></span>
      <input type="text" class="vac-campo__ctrl" maxlength="200"
             [(ngModel)]="borradorSaldo.comentario" name="saldoNota"
             placeholder="Ej. 12 días por 3 años de antigüedad" />
    </label>

    <!-- 20/10/2026: con «lo que le sobra primero», lo que pide para su
         siguiente periodo cuenta aquí si aquí le sobraba. -->
    <p class="vac-modal__nota">
      Los gozados no se capturan: salen de las vacaciones del calendario, en días
      hábiles. Lo que no tome pasa a su siguiente periodo, y lo que pida para ése
      se toma primero de lo que le sobra aquí.
    </p>
  </div>

  <div class="vac-modal__pie">
    <button type="button" class="vac-btn vac-btn--plano" (click)="cerrarSaldo()"
            [disabled]="guardandoSaldo">
      Cancelar
    </button>
    <button type="button" class="vac-btn vac-btn--primario" (click)="guardarSaldo()"
            [disabled]="guardandoSaldo">
      <span class="material-icons">{{ guardandoSaldo ? 'hourglass_top' : 'check' }}</span>
      {{ guardandoSaldo ? 'Guardando…' : 'Guardar' }}
    </button>
  </div>
</div>

<!-- ===== Selector de persona con buscador (15/10/2026) =====
     Uno solo para los tres campos de persona: el colaborador del panel de
     alta y, en el modal de días, de quién son y quién autoriza. Va en el
     mismo mat-form-field de las fechas (.vac-fecha) para que mida y se vea
     igual, también en los temas. Su rótulo es el span «vac-et-<campo>» de
     cada campo. «Nadie en particular» (sólo en quién autoriza) es el
     placeholder: mat-select no pinta el texto de la opción sin valor, que
     sólo sirve para quitar al que estaba, y se esconde mientras se busca
     para que Enter elija a quien se buscó. -->
<ng-template #selectorPersona let-campo>
  <mat-form-field appearance="outline" class="vac-fecha vac-persona" subscriptSizing="dynamic">
    <mat-select #sel="matSelect" [id]="'vac-' + campo" [aria-labelledby]="'vac-et-' + campo"
                [placeholder]="TEXTOS_PERSONA[campo].vacio" panelClass="vac-persona-panel"
                [ngModel]="personaElegida(campo)" [name]="campo"
                (ngModelChange)="eligePersona(campo, $event)"
                (openedChange)="$event ? alAbrirPersona(campo) : alCerrarPersona(sel)">
      <mat-option>
        <ngx-mat-select-search [ngModel]="buscadores[campo].filtro"
                               (ngModelChange)="buscaPersona(campo, $event ?? '')"
                               [placeholderLabel]="TEXTOS_PERSONA[campo].buscar"
                               [ariaLabel]="TEXTOS_PERSONA[campo].buscar"
                               noEntriesFoundLabel="Nadie coincide"></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngIf="campo === 'saldoAutoriza' && !buscadores[campo].filtro" [value]="null">
        {{ TEXTOS_PERSONA[campo].vacio }}
      </mat-option>
      <mat-option *ngFor="let op of buscadores[campo].opciones; trackBy: trackPersona"
                  [value]="op.idUsuario">{{ op.nombre }}</mat-option>
      <!-- Quien está elegido pero ya no viene en la lista (inactivo): sin
           esta opción el campo diría «nadie» aunque se guarde su id. -->
      <mat-option *ngIf="personaFuera(campo) as f" [value]="f.idUsuario">{{ f.nombre }}</mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>

<!-- ==================== FIRMA DEL FRC-019 ==================== -->
<app-firma-frc
  *ngIf="firmaAbierta"
  para="autorizar"
  [nombre]="firmaObjetivo?.colaborador"
  (firmada)="firmada($event)"
  (cancelada)="cierraFirma()"
></app-firma-frc>
